import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SidenavCollapseState {
  isSidenavCollapsed: boolean;
  setIsSidenavCollapsed: (collapsed: boolean) => void;
}

const useSidenavCollapseStore = create<SidenavCollapseState>()(
  persist(
    (set) => ({
      isSidenavCollapsed: false,
      setIsSidenavCollapsed: (collapsed: boolean) =>
        set({ isSidenavCollapsed: collapsed }),
    }),
    {
      name: 'sidenav-collapse-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export { useSidenavCollapseStore };
